import React from 'react';
import {
    Switch,
    Route,
    useRouteMatch,
    useLocation,
    NavLink,
} from 'react-router-dom';
import { connect } from 'react-redux';
import TabPanel from '../../components/TabPanel';
import UploadDocuments from '../../pages/issuer/Dashboard/UploadDocuments';
import CapTableList from '../../pages/issuer/Dashboard/CapTableList';
import BlockchainScreen from '../../pages/issuer/Blockchain/BlockchainScreen';
import EditInvestorInfo from '../../pages/issuer/Investors/EditInvestorInfo';
import ManageClassInfo from '../../pages/issuer/Dashboard/ManageClassInfo';
import SetupWizard from '../../pages/issuer/Dashboard/SetupWizard';
import TAPartners from '../../pages/issuer/Transfer/TAPartners';
import KycPage from '../../pages/issuer/Investors/KycPage';
import Container from '@mui/material/Container';
import Communications from '../../pages/issuer/Investors/Communications';
//import Scenarios from '../../pages/issuer/Investors/Scenarios';
import MuiAlert from '@mui/material/Alert';
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const CapTableRoutes = (props) => {
    let { path } = useRouteMatch();
    const location = useLocation();
    let current_screen = location.pathname.split('/');
    let isWizard = current_screen[current_screen.length - 1] === 'setup-wizard';

    return (
        <Container>
            {!props.profile.has_cap_table &&
                props.profile.scope !== 'list' &&
                !isWizard && (
                    <React.Fragment>
                        <br />
                        <Alert
                            severity="warning"
                            style={{
                                borderRadius: 15,
                                opacity: '80%',
                                fontSize: '1rem',
                            }}
                        >
                            Cap Table has not been detected. You can upload it
                            from the{' '}
                            <b>
                                <NavLink
                                    to={`${path}/setup-wizard`}
                                    style={{
                                        textDecoration: 'underline',
                                        fontSize: '1rem',
                                        color: 'white',
                                    }}
                                >
                                    Setup Wizard tab.{' '}
                                </NavLink>
                            </b>
                        </Alert>
                        <br />
                    </React.Fragment>
                )}

            <TabPanel>
                <Switch>
                    <Route exact path={`${path}/`} component={CapTableList} />
                    <Route
                        exact
                        path={`${path}/class-info`}
                        component={ManageClassInfo}
                        disabled
                    />

                    <Route
                        exact
                        path={`${path}/holder-info`}
                        component={EditInvestorInfo}
                    />
                    <Route exact path={`${path}/kyc`} component={KycPage} />

                    <Route
                        exact
                        path={`${path}/documents`}
                        component={UploadDocuments}
                    />
                    <Route
                        exact
                        path={`${path}/blockchain`}
                        component={BlockchainScreen}
                    />
                    <Route
                        exact
                        path={`${path}/transfer-agents`}
                        component={TAPartners}
                    />

                    {/*    <Route
                        exact
                        path={`${path}/scenarios`}
                        component={Scenarios}
                    />*/}
                    <Route
                        exact
                        path={`${path}/events`}
                        component={Communications}
                    />
                    <Route
                        exact
                        path={`${path}/setup-wizard`}
                        component={SetupWizard}
                    />

                    {/*<Route
                        exact
                        path={`${path}/registered-interests`}
                        component={RegisteredInterests}
                    />*/}
                </Switch>
            </TabPanel>
        </Container>
    );
};

const mapStateToProps = ({ profile }) => {
    return {
        preferredTabs: profile.preferred_tabs,
        profile: profile
    };
};

export default connect(mapStateToProps, null)(CapTableRoutes);
